module.exports = __webpack_public_path__ + "static/logo_72dpi_sans-phrase-610d2c2ad923c201532f99338205b424.png";